import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import SearchResults from "@/pages/SearchResults";
import BusinessDetail from "@/pages/BusinessDetail";
import RegisterBusiness from "@/pages/RegisterBusiness";
import VerifyEmail from "@/pages/VerifyEmail";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import RequestEditLink from "@/pages/RequestEditLink";
import EditBusiness from "@/pages/EditBusiness";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  useEffect(() => {
    // Seed initial data
    const seedData = async () => {
      try {
        await axios.post(`${API}/seed`);
      } catch (e) {
        // Already seeded or error
      }
    };
    seedData();
  }, []);

  return (
    <div className="App min-h-screen bg-sand">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/recherche" element={<SearchResults />} />
          <Route path="/entreprise/:id" element={<BusinessDetail />} />
          <Route path="/inscrire" element={<RegisterBusiness />} />
          <Route path="/verify/:token" element={<VerifyEmail />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/modifier-fiche" element={<RequestEditLink />} />
          <Route path="/modifier/:token" element={<EditBusiness />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
